import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSadComputer = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 252,
	height: 233,
	viewBox: "0 0 252 233",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .502348,
			d: "M41.5 107C41.5 108.933 39.933 110.5 38 110.5C36.067 110.5 34.5 108.933 34.5 107C34.5 105.067 36.067 103.5 38 103.5C39.933 103.5 41.5 105.067 41.5 107Z",
			stroke: "#757E87"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .502348,
			d: "M192.5 186C192.5 187.933 190.933 189.5 189 189.5C187.067 189.5 185.5 187.933 185.5 186C185.5 184.067 187.067 182.5 189 182.5C190.933 182.5 192.5 184.067 192.5 186Z",
			stroke: "#757E87"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .502348,
			d: "M193.5 41C193.5 42.933 191.933 44.5 190 44.5C188.067 44.5 186.5 42.933 186.5 41C186.5 39.067 188.067 37.5 190 37.5C191.933 37.5 193.5 39.067 193.5 41Z",
			stroke: "#757E87"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .502348,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M210 128C211.657 128 213 126.657 213 125C213 123.343 211.657 122 210 122C208.343 122 207 123.343 207 125C207 126.657 208.343 128 210 128Z",
			fill: "#757E87"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .502348,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M105 54C106.657 54 108 52.6569 108 51C108 49.3431 106.657 48 105 48C103.343 48 102 49.3431 102 51C102 52.6569 103.343 54 105 54Z",
			fill: "#757E87"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .502348,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M73 44C74.6569 44 76 42.6569 76 41C76 39.3431 74.6569 38 73 38C71.3431 38 70 39.3431 70 41C70 42.6569 71.3431 44 73 44Z",
			fill: "#757E87"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .502348,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M42.832 169.776V166.72H40V165.072H42.832V162H44.624V165.072H47.456V166.72H44.624V169.776H42.832Z",
			fill: "#757E87"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .502348,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M208.832 65.776V62.72H206V61.072H208.832V58H210.624V61.072H213.456V62.72H210.624V65.776H208.832Z",
			fill: "#757E87"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .502348,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M130.104 41.992V38.936H127.272V37.288H130.104V34.216H131.896V37.288H134.728V38.936H131.896V41.992H130.104Z",
			fill: "#757E87"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M86 76C86 73.7909 87.7909 72 90 72H162C164.209 72 166 73.7909 166 76V152H86V76Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 91,
			y: 152,
			width: 70,
			height: 10,
			fill: "#757E87"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M126 139C126 138.448 126.448 138 127 138H155C155.552 138 156 138.448 156 139V141C156 141.552 155.552 142 155 142H127C126.448 142 126 141.552 126 141V139Z",
			fill: "#757E87"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M96 139C96 138.448 96.4477 138 97 138H100C100.552 138 101 138.448 101 139V141C101 141.552 100.552 142 100 142H97C96.4477 142 96 141.552 96 141V139Z",
			fill: "#757E87"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M99.1485 78.9429C97.4117 78.8175 95.904 80.1281 95.7864 81.8655L93.5001 115.635C93.3832 117.361 94.6837 118.857 96.4096 118.982L152.852 123.057C154.588 123.182 156.096 121.872 156.214 120.135L158.5 86.3651C158.617 84.6387 157.316 83.1426 155.59 83.018L99.1485 78.9429ZM121.469 92.6878C121.6 96.4543 118.719 99.6121 115.032 99.7408C111.346 99.8696 108.251 96.9205 108.119 93.154C107.988 89.3874 110.869 86.2296 114.556 86.1009C118.242 85.9722 121.337 88.9212 121.469 92.6878ZM138.198 98.9319C140.8 98.841 142.834 96.612 142.741 93.9533C142.648 91.2945 140.464 89.2128 137.861 89.3037C135.259 89.3945 133.225 91.6236 133.318 94.2823C133.411 96.9411 135.595 99.0228 138.198 98.9319ZM108.805 112.794L143.441 113.995C143.441 113.995 132.921 104.739 126.615 104.96C120.309 105.18 108.805 112.794 108.805 112.794Z",
			fill: "#757F88"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d",
			x: 36,
			y: 27,
			width: 180,
			height: 180,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 5 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 25 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.458824 0 0 0 0 0.494118 0 0 0 0 0.529412 0 0 0 0.203748 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgSadComputer;
